import { UnknownError } from '@cian/peperrors/shared';

import { EQueryKeys } from 'shared/store/serverSide/EQueryKeys';

export type QueryError = UnknownError;

export type QueryKey = [EQueryKeys.MonolithPython__CianApi_Site_V1_GetUserDataByRequest];

export const getQueryKey = (): QueryKey => [EQueryKeys.MonolithPython__CianApi_Site_V1_GetUserDataByRequest];
